export default {
    'rap.common.button.add': '新增',
    'rap.common.button.submit': 'Submit',
    'rap.common.button.search': 'Search'
}
